import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";

import { Box, Button, Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import Localisation3 from "./Localisation3";

export default function NotaryCard({ state, handleChange }) {
	const [localState, setLocalState] = useState({ ...state, new_loc: false });
	return (
		<Stack direction="column" justifyContent="flex-start" alignItems="stretch" spacing={1}>
			<Typography variant="body1">Vous pouvez renseigner les coordonnées de votre notaire</Typography>
			<Typography variant="body1">Ces informations ne sont pas obligatoires, vous pourrez les saisir dans le dossier de vente</Typography>
			<div>
				<Grid container spacing={1}>
					<Grid item xs={12} sm={6}>
						<TextField
							id="notary_fname"
							name="notary_fname"
							variant="outlined"
							placeholder="Prénom"
							fullWidth
							margin="dense"
							size="small"
							value={state.notary_fname}
							onChange={handleChange}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="notary_lname"
							name="notary_lname"
							variant="outlined"
							placeholder="Nom"
							fullWidth
							margin="dense"
							size="small"
							value={state.notary_lname}
							onChange={handleChange}
						/>
					</Grid>
				</Grid>
			</div>
			<div>
				<Grid container spacing={1}>
					<Grid item xs={12} sm={6}>
						<TextField
							id="notary_raison_sociale"
							name="notary_raison_sociale"
							variant="outlined"
							placeholder="Etude"
							fullWidth
							margin="dense"
							size="small"
							value={state.notary_raison_sociale}
							onChange={handleChange}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="notary_email"
							name="notary_email"
							variant="outlined"
							placeholder="Email"
							fullWidth
							margin="dense"
							size="small"
							value={state.notary_email}
							onChange={handleChange}
						/>
					</Grid>
				</Grid>
			</div>{" "}
			<Stack spacing={1} justifyContent="flex-start">
				{!localState.new_loc && localState.notary_adr1 && <div>
					<Button variant="contained" onClick={() => { setLocalState({ ...localState, new_loc: true }) }}>Modifier</Button>
				</div>}
				{localState.new_loc && localState.notary_adr1 && <div>
					<Button variant="contained" onClick={() => { setLocalState({ ...localState, new_loc: false }) }}>Annuler</Button>
				</div>}

				{(!state.notary_adr1 || localState.new_loc) && <Localisation3

					upperState={{ addr_line1: state.ambassador_addr_line1, addr_zip_code: state.ambassador_addr_zip_code, addr_city: state.ambassador_addr_city }}
					mode="NTR"
					upperSendLoc={handleChange} />}

				{state.notary_adr1 !== "" && <Stack spacing={1} style="margin-top: 10px;">

					<Typography variant="h5">Adresse actuelle</Typography>


					{state.ambassador_addr_line1 !== "" &&

						<Typography variant="body1">{state.notary_adr1}</Typography>

					}

					<Box display={"flex"} justifyContent="flex-start" alignItems={"center"} >
						<Box>
							<Typography variant="body1">{state.notary_cp}</Typography>
						</Box>
						<Box p={1}>
							<Typography variant="body1">{state.notary_ville}</Typography>
						</Box>
					</Box>

				</Stack>}
			</Stack>

		</Stack >
	);
}
